import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import StyledStepper from "../components/StyledStepper";
import PrimeLayout from "../components/PrimeLayout";
import DownloadTemplate from "./sections/DownloadTemplate";
import UploadDocument from "./sections/UploadDocument";
import ProcessingDocument from "./sections/ProcessingDocument";
import OnGoingDocumentDisplay from "../components/elements/OnGoingDocumentsDisplay";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { listProcessing } from "../services/api/newUpload.api";
import Footer from "../components/Footer";

function NewUpload() {
  const [stage, setStage] = useState(0);
  const [downloadMessage, setdDownloadMessage] = useState("");
  const [uploadMessage, setUploadMessage] = useState("");
  const [processingMessage, setProcessingMessage] = useState("");
  const [model, setModel] = useState("init");
  const [country, setCountry] = useState("init");
  const [modelV, setModelV] = useState("init");
  const [modelId, setModelId] = useState(null);
  const [uploadId, setUploadId] = useState(null);
  const [processingData, setProcessingData] = useState(null);
  const [render, setRender] = useState(false);
  const [selectedModelData, setSelectedModelData] = useState(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const checkProcess = async () => {
      try {
        const processingFiles = await listProcessing();
        setProcessingData(processingFiles);
      } catch (err) {
        console.log(err);
      }
    };
    checkProcess();
    const interval = setInterval(() => {
      checkProcess();
    }, 60000);
    return () => clearInterval(interval);
  }, [render]);

  useEffect(() => {
    if (user) {
      if (
        user?.user_role !== "admin" &&
        user?.user_role !== "super_admin" &&
        user?.user_role !== "user" &&
        user?.user_role !== "reporting"
      ) {
        toast.error("You do not have access to this page");
        return navigate("/");
      }
    }
  }, []);

  const clickNextDownload = () => {
    if (processingData?.length < 4) {
      setdDownloadMessage(`${model}|${country}`);
      return setStage(1);
    }
    toast.error("Maximum number of files processing", { theme: "colored" });
  };

  const clickNextUpload = () => {
    setUploadMessage("Upload Successfull");
    setStage(2);
  };

  const clickPrevUpload = () => {
    setdDownloadMessage("");
    setStage(0);
  };

  const clickNextProcessing = () => {
    setdDownloadMessage("");
    setUploadMessage("");
    setProcessingMessage("");
    setModel("init");
    setCountry("init");
    setModelV("init");
    setRender(!render);
    setStage(0);
  };
  return (
    <>
      <Header />
      <Banner small />
      <PrimeLayout title={"Data Extract"}>
        {processingData ? (
          <>
            {processingData.map((data, index) => {
              return (
                <>
                  <OnGoingDocumentDisplay
                    fileName={`${data.template.name}.xlsx`}
                  />
                </>
              );
            })}
          </>
        ) : (
          <></>
        )}
        <StyledStepper
          active={stage}
          label0={downloadMessage}
          label1={uploadMessage}
          label2={processingMessage}
        />
        {stage === 0 && (
          <DownloadTemplate
            onNext={clickNextDownload}
            country={country}
            setCountry={setCountry}
            modelV={modelV}
            setModelV={setModelV}
            model={model}
            setModel={setModel}
            setModelId={setModelId}
            selectedModelData={selectedModelData}
            setSelectedModelData={setSelectedModelData}
          />
        )}
        {stage === 1 && (
          <UploadDocument
            onNext={clickNextUpload}
            onPrev={clickPrevUpload}
            model={model}
            country={country}
            modelV={modelV}
            modelId={modelId}
            uploadId={uploadId}
            setUploadId={setUploadId}
            selectedModelData={selectedModelData}
          />
        )}
        {stage === 2 && (
          <ProcessingDocument
            onNext={clickNextProcessing}
            uploadId={uploadId}
            setProcessingMessage={setProcessingMessage}
            model={model}
          />
        )}
      </PrimeLayout>
      <Footer/>
    </>
  );
}

export default NewUpload;
